<template>
  <div>
    <page-header
      title="Pippeline Settings"
      breadcrumb="CRM  > Pipeline Management > Pipeline Settings"
    />

    <div class="card ">
      <div class="flex justify-between">
        <div>
          <p class="text-deepBlue font-semibold text-lg">
            Your Pipeline Movement
          </p>
        </div>
        <div>
          <img src="@/assets/images/icons/info.svg" alt="information icon" />
        </div>
      </div>

      <div class="container-fluid mt-6">
        <div class="row">
          <div class="col-12 col-md-4 col-lg-4">
            <p class="text-deepBlue font-semibold">Pipeline Conversion</p>
          </div>
          <div class="col-12 col-md-8 col-lg-8">
            <p class="text-deepBlue font-semibold">
              Pipeline Conversion happens?
            </p>
          </div>
        </div>
        <div class="row mt-12">
          <div class="col-12 col-md-4 col-lg-4">
            <p class="text-deepBlue font-semibold text-sm">
              Convert from Lead to Opportunity:
            </p>
          </div>
          <div class="col-12 col-md-8 col-lg-8">
            <div class="w-full md:w-3/5">
              <el-select
                v-model="leadToOpportunityOption"
                placeholder="Select"
                @change="
                  saveCondition('leadToOpportunity', leadToOpportunityOption)
                "
              >
                <el-option
                  v-for="option in movementOptions"
                  :key="option.slug"
                  :label="option.description"
                  :value="option.slug"
                >
                </el-option>
              </el-select>
            </div>
            <div class="flex flex-wrap">
              <div
                v-for="(condition, index) in pipelineSettings.leadToOpportunity
                  .conditions"
                :key="index"
                class="condition flex"
              >
                <p>{{ condition.description }}</p>
                <span
                  class="cursor-pointer pl-4"
                  @click="removeCondition('leadToOpportunity', condition)"
                >
                  X</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-12">
          <div class="col-12 col-md-4 col-lg-4">
            <p class="text-deepBlue font-semibold text-sm">
              Convert from Lead to Sales:
            </p>
          </div>
          <div class="col-12 col-md-8 col-lg-8">
            <div class="w-full md:w-3/5">
              <el-select
                v-model="leadToSaleOption"
                placeholder="Select"
                @change="saveCondition('leadToSale', leadToSaleOption)"
              >
                <el-option
                  v-for="option in movementOptions"
                  :key="option.slug"
                  :label="option.description"
                  :value="option.slug"
                >
                </el-option>
              </el-select>
            </div>
            <div class="flex flex-wrap">
              <div
                v-for="(condition, index) in pipelineSettings.leadToSale
                  .conditions"
                :key="index"
                class="condition flex"
              >
                <p>{{ condition.description }}</p>
                <span
                  class="cursor-pointer pl-4"
                  @click="removeCondition('leadToSale', condition)"
                >
                  X</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-12">
          <div class="col-12 col-md-4 col-lg-4">
            <p class="text-deepBlue font-semibold text-sm">
              Convert from Opportunity to Sales:
            </p>
          </div>
          <div class="col-12 col-md-8 col-lg-8">
            <div class="w-full md:w-3/5">
              <el-select
                v-model="opportunityToSaleOption"
                placeholder="Select"
                @change="
                  saveCondition('opportunityToSale', opportunityToSaleOption)
                "
              >
                <el-option
                  v-for="option in movementOptions"
                  :key="option.slug"
                  :label="option.description"
                  :value="option.slug"
                >
                </el-option>
              </el-select>
            </div>
            <div class="flex flex-wrap">
              <div
                v-for="(condition, index) in pipelineSettings.opportunityToSale
                  .conditions"
                :key="index"
                class="condition flex"
              >
                <p>{{ condition.description }}</p>
                <span
                  class="cursor-pointer pl-4"
                  @click="removeCondition('opportunityToSale', condition)"
                >
                  X</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="my-24">
        <primary-button
          buttonText="Update Settings"
          :loading="loading"
          @click="updateSettings"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";

export default {
  components: {
    PageHeader,
  },
  data() {
    return {
      movementOptions: [],
      selectedMovementOptions: [],
      pipelineSettings: {
        leadToOpportunity: {
          conditions: [],
          slug: "leadToOpportunity",
          title: "Move customer from lead to opportunity",
        },
        leadToSale: {
          conditions: [],
          slug: "leadToSale",
          title: "Move customer from lead to sale",
        },
        opportunityToSale: {
          conditions: [],
          slug: "opportunityToSale",
          title: "Move customer from opportunity to sale",
        },
      },
      leadToOpportunityOption: "",
      leadToSaleOption: "",
      opportunityToSaleOption: "",
      loading: false,
    };
  },
  mounted() {
    this.getPipelineSettings();
    this.getMovementOptions();
  },
  methods: {
    async getPipelineSettings() {
      try {
        const response = await this.$_getPipelineSettings();
        this.logResponse(response);
        this.pipelineSettings = response.data.settings
          ? response.data.settings
          : response.data;
        this.logResponse(this.pipelineSettings);
      } catch (error) {
        this.handleError(error);
      }
    },
    async getMovementOptions() {
      try {
        const response = await this.$_getMovementOptions();
        this.logResponse(response);
        this.movementOptions = response.data.options;
      } catch (error) {
        this.handleError(error);
      }
    },
    async updateSettings() {
      this.loading = true;
      const orgId = localStorage.getItem("organizationId");
      let payload = {
        userInfo: {
          orgId: orgId,
          outletId: null,
          creatorId: orgId,
        },
        payload: {
          setting: {
            ...this.pipelineSettings,
          },
        },
      };
      try {
        const response = await this.$_updatePipelineSettings(payload);
        this.logResponse(response);
        this.generateToast("Settings updated successfully!", "success");
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
    saveCondition(property, selectedSlug) {
      console.log("property:", property, "slug:", selectedSlug);
      let selectedOption = this.movementOptions.filter((option) => {
        return option.slug == selectedSlug;
      });

      // check if option exisits already
      if (
        this.pipelineSettings[property].conditions.indexOf(selectedOption[0]) >=
        0
      ) {
        // clears selected value
        let selectValue = `${property}Option`;
        this[selectValue] = "";
        return;
      }
      this.pipelineSettings[property].conditions.push(selectedOption[0]);
      // clear selected value
      let selectValue = `${property}Option`;
      this[selectValue] = "";
    },
    removeCondition(property, condition) {
      let conditionIndex = this.pipelineSettings[property].conditions.indexOf(
        condition
      );
      this.pipelineSettings[property].conditions.splice(conditionIndex, 1);
      //  this[selectedSlug] = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.condition {
  background: #f2f7fc;
  border: 0.5px solid #8cafd3;
  box-sizing: border-box;
  border-radius: 3px;
  padding: 0.35rem 0.75rem;
  margin: 0.75rem 1rem 0.75rem 0;
  font-size: 0.8rem;
}
</style>
